var ɵ0 = window['_app_base'] || '/';
//Raven
//.config('http://4a915ddd4eb84603b67ab8a127b58087@diaabie.com:9000/6')
//.install();
var AppModule = (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };



// WEBPACK FOOTER //
// ./src/app/app.module.ts.pre-build-optimizer.js